import { axiosClient, getBaseUrlVersioned } from "../../services/axiosClient";
const rulebooksUrl = (path = "") => `${getBaseUrlVersioned(null)}/rulebooks${path}`;
/**
 * `POST /rulebooks/{id}/report` — files a moderation report against a public Rulebook.
 * Mirrors `POST /lorebook/{id}/report` but takes the rulebook DTO shape (`reason_codes` + `details`).
 */
export async function reportRulebook({ rulebookId, reasonCodes, details }) {
    await axiosClient.post(rulebooksUrl(`/${encodeURIComponent(rulebookId)}/report`), {
        reason_codes: reasonCodes,
        ...(details ? { details } : {}),
    });
}
/**
 * `POST /rulebooks/{id}/clone` — copies a public rulebook into the caller's workspace.
 * Server-gated on the definition being visible; the card menu only offers it then.
 */
export async function cloneRulebook(rulebookId) {
    const { data: cloneResponse } = await axiosClient.post(rulebooksUrl(`/${encodeURIComponent(rulebookId)}/clone`));
    return cloneResponse;
}
